/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Icon, Segment } from '@mairistem/composants';

interface Props {
  /** L'étape courante est-elle la première du parcours (ex-`currentStepIndex === 0`) ? */
  isFirstStep: boolean;
  /** L'étape courante est-elle la dernière du parcours (ex-`currentStepIndex === nbSteps`) ? */
  isLastStep: boolean;
  /** En chargement */
  loading: boolean;
  /** Callback appelé lors du clic sur "Étape précédente" */
  onPrevious: () => void;
  /** Callback appelé lors du clic sur "Étape suivante" */
  onNext: () => void;
  /** Callback appelé lors du clique sur le bouton 'Terminer' */
  onFinish: () => void;
}

const AssistantFooter = (props: Props) => {
  // #region Declarations
  const { isFirstStep, isLastStep, onPrevious, onNext, onFinish, loading } =
    props;

  // #endregion

  // #region Component

  return (
    <Segment
      style={{
        display: 'flex',
        borderBottom: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        background: 'transparent',
        boxShadow: 'none',
      }}
    >
      {!isFirstStep && (
        <Button
          data-testid="assistant-etape-precedente"
          onClick={onPrevious}
          disabled={loading}
          loading={loading}
        >
          <Icon name="angle left" />
          Étape précédente
        </Button>
      )}
      <div style={{ flex: 1 }} />
      {isLastStep ? (
        <Button
          positive
          data-testid="assistant-terminer"
          onClick={onFinish}
          disabled={loading}
          loading={loading}
        >
          <Icon name="flag checkered" />
          Terminer
        </Button>
      ) : (
        <Button
          data-testid="assistant-etape-suivante"
          onClick={onNext}
          disabled={loading}
          loading={loading}
        >
          Étape suivante
          <Icon name="angle right" />
        </Button>
      )}
    </Segment>
  );
};

export default AssistantFooter;
